/** Returns the file extension, without the dot. */
export function extractExtension(fileName: string, isUrl: boolean = false) {
  let name = fileName.replace(/^.*\//, ""); // trim path
  if (isUrl) name = name.replace(/(\?|#).*$/, ""); // trim query / hash
  const [, extension] = name.match(/\.([^.]+)$/) ?? [];
  return extension ?? "";
}
